
































































































































































































































































































import { Component, Vue, Watch } from 'vue-property-decorator'
import { formatDate } from '@/utils/tool'
import { getHotelDetail } from '@/api/daolv'
import { HOTEL_INFO } from '@/api/daolv-api'

interface TABLE_DATA {
  img: string
  maxOccupancy: number
  ratePlanList: any[]
  roomName: string
  roomTypeId: string
  signImg: string
  standardOccupancy: number
}

@Component({
  name: 'HotelDetail',
  components: {
  }
})
export default class HotelDetail extends Vue {
  private loading = false
  private productDetail = {} as HOTEL_INFO // 产品详情信息
  private tableData = [] as Array<TABLE_DATA> // 表格产品房型列表
  private expandsKey = [] as any // 展开行的key
  private hotelId = '' // 酒店产品id
  private startDay = formatDate(+new Date(), 'Y-M-D') // 用户选中的入住日期
  private endDay = formatDate(+new Date() + 24 * 60 * 60 * 1000, 'Y-M-D') // 用户选中的离店日期
  private startWeek = '' // 入住周期
  private endWeek = '' // 离店周期
  private readonly weekList = ['周日', '周一', '周二', '周三', '周四', '周五', '周六']
  private roomNum = 1 // 房间数量
  private adultNum = 1 // 成人数量
  private childNum = 0 // 儿童数量
  private contentTabIndex = '0' // 详情Tab切换
  private srcList = [] as Array<string> // 头部imgs

  get srcShowList () { // 展示的图片数组
    return this.srcList.map(item => item)
  }

  get tabIndex () { // 详情下tab切换默认索引
    if (
      this.productDetail.orderPolicy.length > 0 &&
      !this.productDetail.introduction) {
      // 有政策没有简介
      return '1'
    }
    if (
      this.productDetail.hotelFacility.length > 0 &&
      !this.productDetail.introduction &&
      this.productDetail.orderPolicy.length <= 0
    ) {
      // 有设施 没有简介、政策
      return '2'
    }
    if (
      this.productDetail.roomFacility.length > 0 &&
      !this.productDetail.introduction &&
      this.productDetail.orderPolicy.length <= 0 &&
      this.productDetail.hotelFacility.length <= 0
    ) {
      // 有客房信息没有 简介、政策、设施
      return '3'
    }
    return '0'
  }

  get getNight () { // 住共xx晚
    const ms = 86400000 // 一天的毫秒数
    const start = new Date(this.startDay).getTime()
    const end = new Date(this.endDay).getTime()
    const num = (end - start) / ms
    if (isNaN(num)) {
      return 0
    } else {
      return num
    }
  }

  formatDate = formatDate

  @Watch('startDay')
  setStartDay (): void {
    if (+new Date(this.startDay) > +new Date(this.endDay)) {
      console.log('离店日期不可以小于入住日期', this.endDay)
      this.endDay = formatDate(+new Date(this.startDay) + 24 * 60 * 60 * 1000, 'Y-M-D')
      this.endWeek = this.weekList[+new Date(this.endDay).getDay()]
    }
  }

  // 打开地图
  private clickMap = (item) => {
    let latitude = 0
    let longitude = 0
    if (item) {
      latitude = item.latitude || 0
      longitude = item.longitude || 0
    }
    if (latitude && longitude) {
      const url = `http://api.map.baidu.com/geocoder?location=${latitude},${longitude}&coord_type=bd09ll&output=html&src=zowoyoo`
      window.open(url, '_blank')
    }
  }

  // 入住日期改变事件
  changeStartDay (value: Date): void {
    // console.log(value, this.startDay)
    if (+new Date(value) < +new Date() - 24 * 60 * 60 * 1000) {
      console.log('入住日期不能小于当天日期', formatDate(+new Date(), 'Y-M-D'))
      this.$message({
        message: '入住日期不能小于当天日期',
        type: 'warning'
      })
      this.startDay = formatDate(+new Date(), 'Y-M-D')
      return
    }
    this.startDay = formatDate(+new Date(value), 'Y-M-D')
    this.startWeek = this.weekList[new Date(value).getDay()]
    if (+new Date(this.startDay) === +new Date(this.endDay)) {
      this.$message({
        message: '入住日期不能等于离店日期',
        type: 'warning'
      })
      this.endDay = formatDate(+new Date(this.startDay) + 24 * 60 * 60 * 1000, 'Y-M-D')
      this.endWeek = this.weekList[+new Date(this.endDay).getDay()]
    }
    console.log(value, this.startDay, this.endDay)
  }

  // 离店日期改变事件
  changeEndDay (value: Date): void {
    // console.log(value, this.endDay)
    if (+new Date(this.startDay) > +new Date(this.endDay)) {
      console.log('离店日期不可以小于入住日期', this.endDay)
      this.$message({
        message: '离店日期不可以小于入住日期',
        type: 'warning'
      })
      this.endDay = formatDate(+new Date(this.startDay) + 24 * 60 * 60 * 1000, 'Y-M-D')
      this.endWeek = this.weekList[+new Date(this.endDay).getDay()]
      return
    }
    this.endDay = formatDate(+new Date(value), 'Y-M-D')
    this.endWeek = this.weekList[+new Date(value).getDay()]
    console.log(value, this.endDay)
  }

  // 切换详情Tab
  changeTab = (tab): void => {
    // console.log(tab, '+++', event)
    this.contentTabIndex = tab.index
  }

  // 表格点击行展开
  clickRowHandle (row) {
    if (this.expandsKey.includes(row.roomTypeId)) {
      this.expandsKey = this.expandsKey.filter(val => val !== row.roomTypeId)
    } else {
      this.expandsKey.push(row.roomTypeId)
    }
  }

  // 获取产品详情
  getHotelDetail () {
    const loading = this.$loading({
      lock: true,
      text: '正在拼命为您加载，请耐心等候...',
      spinner: 'el-icon-loading',
      background: 'rgba(0, 0, 0, 0.7)',
      customClass: 'loading-class'
    })
    getHotelDetail({
      adultCount: this.adultNum,
      childCount: this.childNum,
      sdate: this.startDay,
      edate: this.endDay,
      hotelId: this.hotelId,
      roomCount: this.roomNum
    }).then(res => {
      loading.close()
      if (res.success) {
        this.srcList = res.hotelInfo.img.split(',') || []
        this.productDetail = res.hotelInfo || {}
        this.tableData = res.roomlList || []
        this.expandsKey = this.tableData.map(it => it.roomTypeId)
      } else {
        console.error(res.msg)
        this.$message.error(res.msg)
      }
    }).catch(err => {
      console.error(err)
    })
  }

  // 去下单页
  goToPlaceOrder (item, row) {
    const queryParams = new URLSearchParams({
      hotelId: this.hotelId,
      startDate: this.startDay,
      endDate: this.endDay,
      startWeek: this.startWeek,
      endWeek: this.endWeek,
      getNight: this.getNight.toString(),
      roomNum: this.roomNum.toString(),
      adultNum: this.adultNum.toString(),
      childNum: this.childNum.toString(),
      ratePlanID: item.ratePlanID, // 酒店计划Id
      maxOccupancy: row.maxOccupancy,
      roomName: row.roomName,
      roomTypeId: row.roomTypeId,
      standardOccupancy: row.standardOccupancy
    })
    console.log(item, row, queryParams)
    const url = `${window.location.origin}/#/hotelReserve?${queryParams.toString()}`
    window.open(url)
  }

  // 初始化数据
  initData () {
    const {
      hotelId,
      startDate,
      endDate,
      startWeek,
      endWeek,
      roomNum,
      adultNum,
      childNum
    } = this.$route.query
    if (hotelId) this.hotelId = String(hotelId)
    if (startDate) this.startDay = String(startDate)
    if (endDate) this.endDay = String(endDate)
    if (startWeek) this.startWeek = String(startWeek)
    if (endWeek) this.endWeek = String(endWeek)
    if (roomNum) this.roomNum = Number(roomNum)
    if (adultNum) this.adultNum = Number(adultNum)
    if (childNum) this.childNum = Number(childNum)
  }

  mounted () {
    this.startWeek = this.weekList[new Date(this.startDay).getDay()]
    this.endWeek = this.weekList[new Date(this.endDay).getDay()]
    this.initData()
    this.getHotelDetail()
  }
}
